<template>
  <div class="question-nav">
    <div
      :class="
        `question-nav__header-wrapper ${
          showQuestions
            ? 'question-nav__header-wrapper--open'
            : 'question-nav__header-wrapper--close'
        }`
      "
    >
      <h5
        :class="[
          'question-nav__title',
          examLayoutV2 && 'question-nav__title--layout-v2',
        ]"
      >
        {{ computedTitle }}
      </h5>
    </div>
    <div class="question-nav__wrapper" v-if="showQuestions">
      <div v-if="!examLayoutV2" class="question-nav__questions__title">
        Questions
      </div>
      <div class="question-nav__questions">
        <span
          :class="questionClasses(question)"
          v-for="question in questions"
          :key="question.uuid || question.question_id"
          @click="$emit('move-to-question', question)"
        ></span>
      </div>
      <div v-if="showNavInfo" class="question-nav__info-wrapper">
        <div class="question-nav__info">
          <span
            class="question-nav__info__bullet question-nav__info__bullet--flagged"
          ></span>
          Pinned
        </div>
        <div class="question-nav__info">
          <span
            class="
          question-nav__info__bullet question-nav__info__bullet--answered
          "
          ></span>
          Answered
        </div>
        <div class="question-nav__info">
          <span class="question-nav__info__bullet"></span> Unanswered
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'QuestionNavigation',
  props: {
    questions: {
      type: Array,
      required: true,
    },
    currentQuestion: {
      type: Object,
      required: true,
    },
    customTitle: {
      type: String,
    },
    examLayoutV2: {
      type: Boolean,
      required: false,
      default: false,
    },
    showNavInfo: {
      type: Boolean,
    },
  },
  data: () => {
    return {
      showQuestions: true,
    }
  },
  computed: {
    computedTitle() {
      if (this.customTitle) return this.customTitle

      return this.examLayoutV2 ? 'Questions summary' : 'Summary'
    },
  },
  methods: {
    questionClasses(question) {
      return {
        'question-nav__question': true,
        'question-nav__question--answered': question.answered,
        'question-nav__question--selected':
          question.uuid === this.currentQuestion?.uuid,
        'question-nav__question--flagged': question.is_flagged,
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.question-nav {
  $this: &;
  background: var(--glass-mid-gray);
  border-radius: 10px;
  padding: 20px 25px;
  &__questions {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 20px;
    margin-top: 10px;
    &__title {
      font-size: rem(16px);
    }
  }
  &__title {
    margin: 0;
    font-size: rem(24px);
    line-height: 32px;
    padding-bottom: 10px;
    border-bottom: 1px solid var(--tundora-gray);
    margin-bottom: 30px;
    &--layout-v2 {
      font-weight: 700;
      font-size: 16px;
      border-bottom: unset;
      padding-bottom: 0;
      margin-bottom: 0;
    }
  }
  &__question {
    width: 18px;
    height: 18px;
    border: 2px solid var(--dove-gray);
    border-radius: 28px;
    opacity: 1;
    cursor: pointer;
    margin: 2px;
    font: normal normal normal 16px/32px var(--font-medium);
    &--answered {
      background: var(--dove-gray) 0% 0% no-repeat padding-box;
    }
    &--selected {
      border: 2px solid var(--cornflower-blue);
    }
    &--flagged {
      border: none;
      background: var(--orange) 0% 0% no-repeat padding-box;
    }
  }
  &__info {
    display: flex;
    align-items: center;

    &-wrapper {
      display: flex;
      gap: 15px;
      @include desktop {
        display: block;
      }
    }
    &__bullet {
      width: 17px;
      height: 17px;
      border-radius: 8px;
      display: inline-block;
      margin: 0 10px 0 0;
      border: 2px solid var(--dove-gray);
      &--answered {
        border: none;
        background: var(--dove-gray) 0% 0% no-repeat padding-box;
      }
      &--selected {
        border: 4px solid var(--cornflower-blue);
      }
      &--flagged {
        border: none;
        background: var(--orange);
      }
    }
    margin-bottom: 10px;
  }
}
</style>
